import { useContext, useEffect, useRef } from "react";
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { Contextone } from "./Context";
import MahuaDesi from "../images/mahuadesi.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { logAnalyticsEvent } from "./Script.js";

function LivePlayer(props) {
  const { id, type_id, video_type, upcoming_type } = useParams();
  const history = useHistory();
  const countercontext = useContext(Contextone);
  const location = useLocation();
  const { url } = location.state || {};
  const videoDataRef = useRef({
    videoid: id,
    durationWatched: 0,
    events: [],
    startTime: null
});

  useEffect(() => {
    const loadQencodeScript = () => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = "https://player-static.qencode.com/release/qencode-bootstrapper.min.js";
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load script'));
        document.body.appendChild(script);
      });
    };

    if (url) {
      loadQencodeScript().then(() => {
        const params = {
          licenseKey: "7b6199e3-9329-3f02-65e7-e7d674722277",
          playback: {
            autoplay: true,
          },
          videoSources: {
            src: `${url}`,
          },
        };

        if (window.qPlayer) {
          window.qPlayer('my_player', params, function () {

            const videoElement = document.querySelector('.video-js.vjs-fluid');

            if (videoElement) {
              videoElement.style.paddingTop = '45.5vw';

              // Add analytics event listeners
              const playerInstance = videoElement.querySelector('video');
              
              if (playerInstance) {
                playerInstance.addEventListener('play', () => {
                  const videoData = videoDataRef.current;
                  videoData.startTime = Date.now();
                  videoData.videoid = id;
                  videoData.events.push({ event: 'play', timestamp: new Date().toISOString() });
                  logAnalyticsEvent('play', {
                    videoname : id,
                    // id,
                    timestamp: new Date().toISOString(), 
                });
                
                });

                playerInstance.addEventListener('pause', () => {
                  const videoData = videoDataRef.current;
                  if (videoData.startTime) {
                      const watchTime = (Date.now() - videoData.startTime) / 1000;
                      videoData.durationWatched += watchTime;
                      videoData.videoid = id;
                      videoData.events.push({ event: 'pause', timestamp: new Date().toISOString(), watchTime });
                      logAnalyticsEvent('pause', {
                        // id,
                        videoname : id,
                        timestamp: new Date().toISOString(), 
                        watchTime
                    });
                      videoData.startTime = null;
                  }
                });

                playerInstance.addEventListener('ended', () => {
                  const videoData = videoDataRef.current;
                  if (videoData.startTime) {
                      const watchTime = (Date.now() - videoData.startTime) / 1000;
                      videoData.durationWatched += watchTime;
                      videoData.videoid = id;
                      videoData.events.push({ event: 'ended', timestamp: new Date().toISOString(), watchTime });
                      logAnalyticsEvent('ended', {
                        // id,
                        videoname : id,
                        timestamp: new Date().toISOString(), 
                        watchTime
                    });
                      videoData.startTime = null;
                  }
                });

                playerInstance.addEventListener('loadeddata', () => {
                  const videoData = videoDataRef.current;
                  if (videoData.startTime) {
                      const watchTime = (Date.now() - videoData.startTime) / 1000;
                      videoData.durationWatched += watchTime;
                      videoData.videoid = id;
                      videoData.events.push({ event: 'loaded', timestamp: new Date().toISOString(), watchTime });
                      logAnalyticsEvent('loaded', {
                        // id,
                        videoname : id,
                        timestamp: new Date().toISOString(), 
                        watchTime
                    });
                      videoData.startTime = null;
                  }
                  });
              } else {
                console.error("Video element not found for event listeners.");
              }
            } else {
              console.error("Video container not found.");
            }
          });
        } else {
          console.error("qPlayer is not defined");
        }
      }).catch((err) => {
        console.error("Failed to load Qencode player script", err);
      });
    }
  }, [url]);

  return (
    <>
      {url ? (
        <div>
          <div className="top-left-button">
            <button
              onClick={() => history.goBack()}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '24px',
                color: '#000',
                cursor: 'pointer',
              }}
            >
              <FontAwesomeIcon icon={faArrowLeft} style={{ color: 'white' }} />
            </button>
            {countercontext.isDomain === 'mahuaplay.ottsnap.in' && (
              <img src={MahuaDesi} height="67px" alt="Logo" />
            )}
          </div>
          <div id="my_player" style={{ width: '100vw', maxWidth: '100%', overflow: 'hidden' }}></div>
        </div>
      ) : (
        <div>
          {id && type_id && parseInt(video_type) === 0
            ? history.push('/')
            : history.push(`/videodetails/${type_id}/${id}/${upcoming_type}/${video_type}`)}
        </div>
      )}
    </>
  );
}

export default LivePlayer;
